export enum ProductType {
  Loans = 'loans',
  Shares = 'shares',
}
